export const base = {"fill":"onSurface"};
export const baseAlt = {"aliases":["surfaceContainerVariant"],"bg":"surfaceContainerVariant"};
export const accent = {"aliases":["primary"],"fill":"primary"};
export const accentAlt = {"aliases":["primaryContainer"],"bg":"primaryContainer","fill":"onPrimaryContainer"};
export const warning = {"fill":"warning"};
export const warningAlt = {"aliases":["warningContainer"],"bg":"warningContainer","fill":"onWarningContainer"};
export const error = {"fill":"error"};
export const errorAlt = {"aliases":["errorContainer"],"bg":"errorContainer","fill":"onErrorContainer"};
export const success = {"fill":"success"};
export const successAlt = {"aliases":["successContainer"],"bg":"successContainer","fill":"onSuccessContainer"};
export const connect = {"aliases":["connectAlt"],"bg":"connect","fill":"onConnect"};
export const keyExchange = {"aliases":["keyExchangeAlt"],"bg":"keyExchange","fill":"onKeyExchange"};
export const disabled = {"aliases":["onSurfaceDisabled"],"fill":"onSurfaceDisabled"};
export const disabledAlt = {"bg":"disabled","fill":"onSurfaceDisabled"};
export const info = {"fill":"tertiary"};
export const infoAlt = {"aliases":["tertiaryContainer"],"bg":"tertiaryContainer","fill":"onSurface"};
export const driver = {"fill":"secondary"};
export const driverAlt = {"bg":"secondaryContainer","fill":"onSecondaryContainer"};
export const owner = {"fill":"tertiary"};
export const ownerAlt = {"bg":"tertiaryContainer","fill":"tertiary"};
export const onTertiaryContainer = {"fill":"onTertiaryContainer"};
export const surface = {"bg":"onSurface","fill":"surface"};
export default {
  "base": { "fill": "onSurface" },
  "baseAlt": {
    "aliases": ["surfaceContainerVariant"],
    "bg": "surfaceContainerVariant"
  },
  "accent": { "aliases": ["primary"], "fill": "primary" },
  "accentAlt": {
    "aliases": ["primaryContainer"],
    "bg": "primaryContainer",
    "fill": "onPrimaryContainer"
  },
  "warning": { "fill": "warning" },
  "warningAlt": {
    "aliases": ["warningContainer"],
    "bg": "warningContainer",
    "fill": "onWarningContainer"
  },
  "error": { "fill": "error" },
  "errorAlt": {
    "aliases": ["errorContainer"],
    "bg": "errorContainer",
    "fill": "onErrorContainer"
  },
  "success": { "fill": "success" },
  "successAlt": {
    "aliases": ["successContainer"],
    "bg": "successContainer",
    "fill": "onSuccessContainer"
  },
  "connect": {
    "aliases": ["connectAlt"],
    "bg": "connect",
    "fill": "onConnect"
  },
  "keyExchange": {
    "aliases": ["keyExchangeAlt"],
    "bg": "keyExchange",
    "fill": "onKeyExchange"
  },
  "disabled": { "aliases": ["onSurfaceDisabled"], "fill": "onSurfaceDisabled" },
  "disabledAlt": { "bg": "disabled", "fill": "onSurfaceDisabled" },
  "info": { "fill": "tertiary" },
  "infoAlt": {
    "aliases": ["tertiaryContainer"],
    "bg": "tertiaryContainer",
    "fill": "onSurface"
  },
  "driver": { "fill": "secondary" },
  "driverAlt": { "bg": "secondaryContainer", "fill": "onSecondaryContainer" },
  "owner": { "fill": "tertiary" },
  "ownerAlt": { "bg": "tertiaryContainer", "fill": "tertiary" },
  "onTertiaryContainer": { "fill": "onTertiaryContainer" },
  "surface": { "bg": "onSurface", "fill": "surface" }
}
;